import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../assets/images/facebook-icon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/instagram-icon.svg";
import Terms from "../../assets/legal/terms_of_use.pdf";
import {
  redirect_to,
  hardcoded_event,
  rights,
  homepage_link,
  logo,
  company_info,
  table_contact,
  isLandingPath,
} from "./../../constants";

const TableCta = () => {
    const [closed, setClosed] = useState(false);

    if (closed) return null;

    return (
      <section className="table-cta" aria-labelledby="table-cta-title">
        <button
          type="button"
          className="table-cta__close"
          aria-label="Close"
          onClick={() => setClosed(true)}
        >
          ×
        </button>
        <h2 id="table-cta-title" className="table-cta__title">
          Looking for a table?
        </h2>
        <div className="table-cta__actions">
          {table_contact.phone && (
            <a
              className="table-cta__button"
              href={`https://wa.me/${table_contact.phone.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp us
            </a>
          )}
          <a
            className="table-cta__button table-cta__button--outline"
            href={`mailto:${table_contact.email}`}
            title={table_contact.email}
          >
            Email us
          </a>
        </div>
      </section>
    );
};

const Footer = () => {
    const location = useLocation();
    const onLanding = isLandingPath(location.pathname);

    return (
      <footer className="footer">
        {table_contact && onLanding && <TableCta key={location.key} />}
        <div className="footer__container">
          <p className="footer__text">
            ©{new Date().getFullYear()}  {rights}
          </p>
          {company_info && (
            <p className="footer__text">
              {company_info}
            </p>
          )}
          {/*}
          <ul className="footer__links">
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
          */}
        </div>
      </footer>
    );
  };

  export default Footer;
